import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { doLogoutAndForget as doLogoutAndForgetAction } from 'shared/app/shell';
import ContentCrateLoading from 'shared/app/components/content-crate-loading';

import getReturnUrlFromWindow from 'shared/app/utils/get-return-url-from-window';

const SignOut = ({ doLogout }) => {
  useEffect(() => {
    const returnUrl = getReturnUrlFromWindow() || '/';
    doLogout(returnUrl);
  }, []);

  return (
    <div className="py6 height-100">
      <ContentCrateLoading />
    </div>
  );
};

const actions = {
  doLogout: doLogoutAndForgetAction,
};

export default connect(null, actions)(SignOut);
